import * as React from "react";
import { Mail, Phone, MapPin } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
export default function Contact() {
  const businessName = "Ceeday Detailing";
  const email = "contact@ceedaydetailing.com";
  const phone = "";
  return;
}